import { Flex, TextField, Popover, Button } from '@radix-ui/themes';
import React from 'react';
import DatePicker, { DatePickerProps } from 'react-datepicker';
import './date-picker.css';
import { parse, format } from 'date-fns';

export const AppDatePicker = ({
    inputProps,
    onSelect,
    inputDateFormat = 'dd-MM-yyyy',
    outputDateFormat = 'dd-MM-yyyy',
}: Pick<DatePickerProps, 'maxDate' | 'maxDate'> & {
    onSelect?: (dateString: string) => void;
    inputProps: TextField.RootProps;
    inputDateFormat?: string;
    outputDateFormat?: string;
}) => {
    const [showDatePicker, setShowDatePicker] = React.useState(false);

    let selectingDate;
    if (inputProps.value && typeof inputProps.value === 'string') {
        selectingDate = parse(inputProps.value, inputDateFormat, new Date());
    } else {
        selectingDate = undefined;
    }

    return (
        <Flex >
            <Popover.Root open={showDatePicker} onOpenChange={setShowDatePicker}>
                <Popover.Trigger>
                    <Button className="date-picker__trigger" color="blue" highContrast>
                        <TextField.Root
                            {...inputProps}
                            readOnly
                            className="date-picker__input"
                        ></TextField.Root>
                    </Button>
                </Popover.Trigger>
                <Popover.Content side="bottom" align="start">
                    {
                        <DatePicker
                            selected={selectingDate}
                            showPopperArrow={false}
                            onChange={(date) => {
                                let value: Date | null | string = date;
                                if (date) {
                                    value = format(date, outputDateFormat);
                                    onSelect?.(value);
                                }
                                setShowDatePicker(false);
                            }}
                            popperPlacement="bottom-start"
                            withPortal={false}
                            strictParsing
                            inline
                        />
                    }
                </Popover.Content>
            </Popover.Root>
        </Flex>
    );
};
